<template>
  <div>
    <v-dialog
      v-model="show"
      width="650px"
      content-class="rounded-xl"
    >
      <v-card rounded="xl">
        <v-card-title>
          Данные пользователя
        </v-card-title>
        <v-form>
          <v-card-text>

            <div class="d-flex justify-center align-center">
              <v-divider/>
              <div class="mx-1 text-subtitle-2 font-weight-light">
                Должность<span class="text-h6">*</span>
              </div>
              <v-divider/>
            </div>

            <v-chip-group column class="my-4" v-model="payloadOrder.academic_title">
              <v-chip v-for="title in academicTitles" :key="title.name" filter outlined :value="title.name">
                {{title.name}}
              </v-chip>
            </v-chip-group>

            <div class="d-flex justify-center align-center">
              <v-divider/>
              <div class="mx-1 text-subtitle-2 font-weight-light">
                Ставка<span class="text-h6">*</span>
              </div>
              <v-divider/>
            </div>

            <v-chip-group class="my-4" v-model="payloadOrder.bid" column>
              <v-chip v-for="bid in bids" :key="bid.name" filter outlined filter-icon="fa fa-check" :value="bid.name">
                {{bid.name}}
              </v-chip>
            </v-chip-group>

            <div class="d-flex justify-center align-center">
              <v-divider/>
              <div class="mx-1 text-subtitle-2 font-weight-light">
                Дополнительный показатель
              </div>
              <v-divider/>
            </div>

            <v-row>
              <v-col>
                <v-checkbox
                  v-model="payloadOrder.dean"
                  label="Декан"
                >
                </v-checkbox>
              </v-col>
              <v-col>
                <v-checkbox
                  v-model="payloadOrder.head_department"
                  label="Заведующий кафедрой"
                >
                </v-checkbox>
              </v-col>
            </v-row>
            <v-scroll-y-transition>
              <v-alert v-show="flagErrors" color="error" outlined class="rounded-xl">
                Не выбраны обязательные поля (*)
              </v-alert>
            </v-scroll-y-transition>
          </v-card-text>
          <v-card-actions>
            <v-spacer/>
            <v-btn
              @click="show = false"
              elevation="0"
              outlined
              class="rounded-xl"
              color="teal darken-3"
              :loading="loadingData"
            >
              Отмена
            </v-btn>
            <v-btn
              v-if="teachersList.length > 1"
              @click="showConfirmationDialog = true"
              color="teal darken-3"
              elevation="0"
              :loading="loadingData"
              class="rounded-xl white--text"
            >
              Сохранить
              <v-icon small right>fa-users</v-icon>
            </v-btn>
            <v-btn
              v-else
              @click="sentDataForm"
              color="teal darken-3"
              elevation="0"
              :loading="loadingData"
              class="rounded-xl white--text"
            >
              Сохранить
              <v-icon small right>fa-user</v-icon>
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="showConfirmationDialog"
      width="650px"
      content-class="rounded-xl"
    >
      <v-card class="rounded-xl">
        <v-card-title>
          Внимание
        </v-card-title>
        <v-card-text>
          Вы пытаетесь изменить данные в заполненном шаблоне нескольких пользователей.
          Если вы уверены,
          что хотите изменить данные выбранных пользователей, нажмите кнопку "Продолжить".
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn
            outlined
            color="teal darken-3"
            class="rounded-xl"
            @click="showConfirmationDialog = false"
            :loading="loadingData"
          >
            Отмена
          </v-btn

          >
          <v-btn
            @click="sentDataForm"
            class="white--text rounded-xl"
            color="teal darken-3"
            :loading="loadingData"
          >
            Продолжить
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import ApiServices from "../services/api.services";
import {mapMutations} from "vuex";

export default {
  name: "TheEditTeacherOrderDialog",

  props: {
    visible: Boolean,
    teachersList: Array
  },

  mounted() {
    let bid = 0.1;
    const step = 0.05;

    while(bid < 1.05) {
      this.bids.push({name: bid.toFixed(2)});
      bid += step;
    }
  },

  data() {
    return {

      academicTitles: [
        {name: "Ассистент"},
        {name: "Старший преподаватель"},
        {name: "Доцент"},
        {name: "Профессор"},
      ],
      bids: [],
      flagErrors: false,
      payloadOrder: {
        bid: null,
        academic_title: null,
        dean: false,
        head_department: false,
      },
      loadingData: false,
      showConfirmationDialog: false,
    };
  },

  computed: {
    show: {
      get() {
        if (this.visible) this.setPayloadOnlyOneTeacher();
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.resetData();
          this.$emit('close');
        }
      }
    },

  },

  methods: {

    ...mapMutations({
      setTeachersList: "effective_contract/setTeachersList",
    }),

    resetData() {
      this.payloadOrder = {
        bid: null,
        academic_title: null,
        dean: false,
        head_department: false,
      }
    },

    setPayloadOnlyOneTeacher() {
      if (this.teachersList.length > 1) return;
      const teacherOrder = _.cloneDeep(this.teachersList[0].teacher_eff_order);

      this.payloadOrder = {
          bid: teacherOrder.bid.toFixed(2),
          academic_title: teacherOrder.academic_title,
          dean: teacherOrder.dean,
          head_department: teacherOrder.head_department,
      }
    },

    async sentDataForm() {
      const bid = this.payloadOrder.bid;
      const academic_title = this.payloadOrder.academic_title;
      const flagOccupancy = academic_title === null || academic_title === undefined || bid === null || bid === undefined

      if (flagOccupancy) {
        this.showConfirmationDialog = false;
        this.flagErrors = true;
        return;
      }

      const ids = _.map(this.teachersList, (i) => i.teacher_eff_order.id) ;
      this.loadingData = true;

      const response = await ApiServices.editOrdersWithUmuManager(ids, this.payloadOrder)
      if (response?.statusText === "OK") {
        await this.setTeachersList(response.data.teachers_list);
        this.showConfirmationDialog = false;
        this.show = false;
        this.flagErrors = false;
      }
      this.loadingData = false;
    },

  },

}
</script>

<style scoped>

</style>